import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Componente que muestra el detalle de una salida por traspaso de cabotaje en modo de solo lectura.
 */
@Component({
  selector: 'app-cabotaje-form-salida-traspaso-detail',
  templateUrl: './cabotaje-form-salida-traspaso-detail.component.html',
  styles: [`
    @media (max-width: 950px) {
      .container-grid {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
  `]
})
export class CabotajeFormSalidaTraspasoDetailComponent implements OnInit {
  containerStyles = {
    'grid-template-columns': 'repeat(4, 1fr)'
  };
  @Output() onRegresar = new EventEmitter<boolean>();
  @Input() entry: any;
  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Emite el evento para regresar a la vista anterior del detalle de traspaso.
   */
  regresar() {
    this.onRegresar.emit(true);
  }
}
